import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./shelfaudit.css";
import Table from "react-bootstrap/Table";
import logUserActivity from "../utils/logUserActivity";
import { CSVLink } from "react-csv";

function Shelfaudit() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [savingIndex, setSavingIndex] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);



  const fetchData = async () => {
    try {
      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getManageshelf`
      );

      const itemsWithOwner = await Promise.all(
        response.data.map(async (item) => {
          try {
            const ownerRes = await Axios.get(
              `${INVENTORY_API_BASE_URL}/get-owner`,
              {
                params: {
                  shelfno: item.shelfno,
                  sku: item.sku,
                },
              }
            );

            return {
              ...item,
              enteredCount: "",
              owner: ownerRes.data.owner || "",
              subowner: ownerRes.data.subowner || "",
              ownerInput: "",
              subownerInput: "",
            };
          } catch (err) {
            console.warn(
              `No owner data for shelf ${item.shelfno} SKU ${item.sku}`
            );
            return {
              ...item,
              enteredCount: "",
              owner: "",
              subowner: "",
              ownerInput: "",
              subownerInput: "",
            };
          }
        })
      );

      const sorted = itemsWithOwner.sort((a, b) =>
        a.rackno.localeCompare(b.rackno, undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );

      setData(sorted);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const totalPresentQuantity = data.reduce((acc, item) => {
    const qty = Number(item.presentquantity);
    return acc + (isNaN(qty) ? 0 : qty);
  }, 0);

  const totalPhysicalCount = data.reduce((acc, item) => {
    const qty = Number(item.physicalCount);
    return acc + (isNaN(qty) ? 0 : qty);
  }, 0);

  const totalFreezeQuantity = data.reduce((acc, item) => {
    const qty = Number(item.freeze);
    return acc + (isNaN(qty) ? 0 : qty);
  }, 0);

  const difference = totalFreezeQuantity - totalPhysicalCount;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleOwnerSubmit = async (item, index) => {
    const payload = {
      shelfno: item.shelfno,
      sku: item.sku,
      rackno: item.rackno,
      title: item.title,
      edition: item.edition,
      Medium: item.Medium,
      owner: item.ownerInput || "",
      subowner: item.subownerInput || "",
    };

    if (!payload.owner || !payload.subowner) {
      alert("Please fill both Owner and Subowner fields.");
      return;
    }

    try {
      setSavingIndex(index);

      await Axios.put(
        `${INVENTORY_API_BASE_URL}/update-owner`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      await logUserActivity("UPDATE_OWNER_SUBOWNER", payload);

      const updatedData = [...data];
      updatedData[index].owner = payload.owner;
      updatedData[index].subowner = payload.subowner;
      updatedData[index].ownerInput = "";
      updatedData[index].subownerInput = "";
      setData(updatedData);
    } catch (err) {
      console.error("PUT Error:", err.response?.data || err);
      alert("❌ Failed to save Owner/Subowner.");
    } finally {
      setTimeout(() => setSavingIndex(null), 1000);
    }
  };

  const handleSubmit = async (item, index) => {
    const payload = {
      rackno: item.rackno,
      shelfno: item.shelfno,
      sku: item.sku,
      title: item.title,
      Medium: item.Medium,
      edition: item.edition,
      presentquantity: Number(item.presentquantity) || 0,
      scanCount: Number(item.scanCount) || 0,
      physicalCount: Number(item.enteredCount),
      freeze: Number(item.presentquantity) || 0,
    };

    if (!payload.physicalCount && payload.physicalCount !== 0) {
      alert("Please enter physical count before submitting.");
      return;
    }

    try {
      await Axios.put(
        `${INVENTORY_API_BASE_URL}/updateScanValue`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      await logUserActivity("UPDATE_PHYSICAL_COUNT", payload);

      alert("✅ Saved successfully");
      fetchData();
    } catch (err) {
      console.error("PUT Error:", err.response?.data || err);
      alert("❌ Failed to save.");
    }
  };

  const csvHeaders = [
    { label: "Rack No", key: "rackno" },
    { label: "Shelf No", key: "shelfno" },
    { label: "SKU", key: "sku" },
    { label: "Title", key: "title" },
    { label: "Medium", key: "Medium" },
    { label: "Edition", key: "edition" },
    { label: "Virtual Quantity", key: "presentquantity" },
    { label: "Freeze Quantity", key: "freeze" },
    { label: "Physical Count", key: "physicalCount" },
    { label: "Difference (Freeze - Physical)", key: "difference" },
    { label: "Scan Count", key: "scanCount" },
     { label: "Owner", key: "owner" },
  { label: "Subowner", key: "subowner" },
    { label: "Updated Date", key: "updatedAtFormatted" },
  ];

  const csvData = data.map((item) => {
    const physical = item.physicalCount ?? item.enteredCount ?? "";
    const freeze = Number(item.freeze || 0);
    const physicalNum = Number(physical || 0);
    const difference = freeze - physicalNum;

    return {
      ...item,
      physicalCount: physical,
      difference: isNaN(difference) ? "" : difference,
        owner: item.owner,
    subowner: item.subowner,
      updatedAtFormatted: formatDate(item.updatedAt),
    };
  });

  const filteredData = data.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.rackno?.toLowerCase().includes(term) ||
      item.shelfno?.toLowerCase().includes(term) ||
      item.sku?.toLowerCase().includes(term) ||
      item.title?.toLowerCase().includes(term)
    );
  });

  return (
    <main className="shelf-audit-page">
      <div className="shelf-audit__content">
        <header className="shelf-audit__header">
          <div>
            <p className="shelf-audit__eyebrow">Inventory control</p>
            <h1>Shelf audit</h1>
            <p className="shelf-audit__subtitle">
              Compare recorded shelf quantities with the physical count and assign shelf ownership.
            </p>
          </div>
          <span className="shelf-audit__header-badge">
            {data.length.toLocaleString()} shelf records
          </span>
        </header>

        <section className="shelf-audit__stats" aria-label="Shelf audit totals">
          <article className="shelf-audit__stat-card">
            <span className="shelf-audit__stat-label">Virtual quantity</span>
            <strong>{Number(totalPresentQuantity || 0).toLocaleString()}</strong>
            <span className="shelf-audit__stat-note">Recorded present quantity</span>
          </article>
          <article className="shelf-audit__stat-card shelf-audit__stat-card--accent">
            <span className="shelf-audit__stat-label">Freeze quantity</span>
            <strong>{Number(totalFreezeQuantity || 0).toLocaleString()}</strong>
            <span className="shelf-audit__stat-note">Quantity frozen for audit</span>
          </article>
          <article className="shelf-audit__stat-card">
            <span className="shelf-audit__stat-label">Physical count</span>
            <strong>{Number(totalPhysicalCount || 0).toLocaleString()}</strong>
            <span className="shelf-audit__stat-note">Previously submitted count</span>
          </article>
          <article className={"shelf-audit__stat-card shelf-audit__stat-card--variance " + (difference === 0 ? "is-balanced" : difference < 0 ? "is-short" : "is-over")}>
            <span className="shelf-audit__stat-label">Variance · freeze minus physical</span>
            <strong>{Number(difference || 0).toLocaleString()}</strong>
            <span className="shelf-audit__stat-note">Across all shelf records</span>
          </article>
        </section>

        <section className="shelf-audit__tools" aria-label="Search and export shelf audit">
          <div>
            <h2>Find shelf records</h2>
            <p>Search by rack, shelf, SKU, or title.</p>
          </div>
          <div className="shelf-audit__tool-actions">
            <label className="shelf-audit__search">
              <span aria-hidden="true">⌕</span>
              <span className="shelf-audit__visually-hidden">Search shelf records</span>
              <input
                type="search"
                placeholder="Search item details..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </label>
            <CSVLink
              data={csvData}
              headers={csvHeaders}
              filename="shelf_audit_report.csv"
              className="shelf-audit__export"
            >
              <span aria-hidden="true">↓</span>
              Download CSV
            </CSVLink>
          </div>
        </section>

        {loading ? (
          <div className="shelf-audit__message" role="status">
            <span className="shelf-audit__spinner" aria-hidden="true" />
            <strong>Loading shelf audit…</strong>
            <span>Retrieving shelf quantities and owner details.</span>
          </div>
        ) : data.length === 0 ? (
          <div className="shelf-audit__message">
            <span className="shelf-audit__message-icon" aria-hidden="true">▤</span>
            <strong>No shelf records available</strong>
            <span>There are no shelf records to audit right now.</span>
          </div>
        ) : (
          <section className="shelf-audit__table-panel" aria-label="Shelf audit records">
            <div className="shelf-audit__table-heading">
              <div>
                <h2>Audit register</h2>
                <p>Enter owner details or submit the physical count for a shelf.</p>
              </div>
              <span className="shelf-audit__record-count">
                {filteredData.length.toLocaleString()} matching records
              </span>
            </div>

            <div className="shelf-audit__table-scroll">
              <Table hover className="shelf-audit__table">
                <thead>
                  <tr>
                    {[
                      "Sr. No.",
                      "Rack",
                      "Shelf",
                      "Owner",
                      "Subowner",
                      "Owner action",
                      "SKU",
                      "Title",
                      "Medium",
                      "Edition",
                      "Virtual qty.",
                      "Freeze qty.",
                      "Physical count",
                      "Variance",
                      "Scan count",
                      "Updated date",
                      "Enter physical count",
                    ].map((header) => (
                      <th key={header} scope="col">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr>
                      <td className="shelf-audit__empty" colSpan={17}>
                        <strong>No matching shelf records</strong>
                        <span>Try another rack, shelf, SKU, or title.</span>
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((item, index) => {
                      const rowDifference =
                        Number(item.freeze || 0) - Number(item.physicalCount || 0);

                      return (
                        <tr key={index}>
                          <td className="shelf-audit__serial-cell">{index + 1}</td>
                          <td className="shelf-audit__location-cell">{item.rackno}</td>
                          <td className="shelf-audit__location-cell">{item.shelfno}</td>

                          <td className="shelf-audit__owner-cell">
                            <input
                              type="text"
                              aria-label={"Owner for shelf " + item.shelfno}
                              placeholder="Enter owner"
                              value={item.ownerInput}
                              onChange={(e) => {
                                const updated = [...data];
                                updated[index].ownerInput = e.target.value;
                                setData(updated);
                              }}
                            />
                            <small>Current: <strong>{item.owner || "Not set"}</strong></small>
                          </td>

                          <td className="shelf-audit__owner-cell">
                            <input
                              type="text"
                              aria-label={"Subowner for shelf " + item.shelfno}
                              placeholder="Enter subowner"
                              value={item.subownerInput}
                              onChange={(e) => {
                                const updated = [...data];
                                updated[index].subownerInput = e.target.value;
                                setData(updated);
                              }}
                            />
                            <small>Current: <strong>{item.subowner || "Not set"}</strong></small>
                          </td>

                          <td>
                            <button
                              type="button"
                              className="shelf-audit__owner-save"
                              onClick={() => handleOwnerSubmit(item, index)}
                              disabled={savingIndex === index}
                            >
                              {savingIndex === index ? "Saving…" : "Save owner"}
                            </button>
                          </td>

                          <td className="shelf-audit__sku-cell">{item.sku}</td>
                          <td className="shelf-audit__title-cell" title={item.title || ""}>{item.title}</td>
                          <td>{item.Medium}</td>
                          <td>{item.edition}</td>
                          <td className="shelf-audit__number-cell">{item.presentquantity}</td>
                          <td className="shelf-audit__number-cell">{item.freeze}</td>
                          <td className="shelf-audit__number-cell">{item.physicalCount}</td>
                          <td className="shelf-audit__number-cell">
                            <span className={"shelf-audit__variance " + (rowDifference === 0 ? "is-balanced" : rowDifference < 0 ? "is-short" : "is-over")}>
                              {rowDifference}
                            </span>
                          </td>
                          <td className="shelf-audit__number-cell">{item.scanCount}</td>
                          <td className="shelf-audit__date-cell">{formatDate(item.updatedAt) || "—"}</td>

                          <td>
                            <div className="shelf-audit__count-entry">
                              <input
                                type="number"
                                aria-label={"Physical count for shelf " + item.shelfno}
                                value={item.enteredCount || ""}
                                onChange={(e) => {
                                  const updated = [...data];
                                  const realIndex = updated.findIndex(
                                    (d) => d._id === item._id
                                  );
                                  if (realIndex !== -1) {
                                    updated[realIndex].enteredCount = e.target.value;
                                    setData(updated);
                                  }
                                }}
                                placeholder="Enter count"
                              />
                              <button
                                type="button"
                                className="shelf-audit__count-save"
                                onClick={() => handleSubmit(item, index)}
                              >
                                Save count
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </div>
            <footer className="shelf-audit__table-footer">
              Counts and owner updates are saved per shelf record.
              <span>Use the table’s horizontal scroll to view all audit fields.</span>
            </footer>
          </section>
        )}
      </div>
    </main>
  );
}

export default Shelfaudit;